import { useEffect, useState } from 'react';

import { useConvertMediaMutation } from './graphql/mutation/generated/convertMedia';
import { useGetConversionJobQuery } from './graphql/queries/generated/getConversionJob';
import { useConversionJobSubscription } from './graphql/subscription/generated/conversionJob';
import { useConvertFileType } from './types';

export const CONVERTIBLE_FILES = ['ppt', 'pptx', 'doc', 'docx', 'xls', 'xlsx'];

const useConvertFile: useConvertFileType = ({ src, jobToken, type, targetType }) => {
  const isConvertible = type && CONVERTIBLE_FILES.includes(type);
  const validRequest = type && src && targetType && isConvertible;

  const [data, setData] = useState<ReturnType<useConvertFileType>['data'] | null>(null);
  const [error, setError] = useState<ReturnType<useConvertFileType>['error'] | null>(null);

  const queryOptions = { pause: !jobToken, variables: { input: { jobScheduleId: jobToken! } } };

  const [, createConversion] = useConvertMediaMutation();
  const [{ data: jobInfo, error: queryError }] = useGetConversionJobQuery(queryOptions);
  const [{ data: jobSubscription, error: subscriptionError }] =
    useConversionJobSubscription(queryOptions);

  useEffect(() => {
    if (validRequest && !jobToken) {
      createConversion({ input: { from: type!, to: targetType, url: src! } }).then((resp) => {
        if (resp.data?.convertMedia?.jobScheduleId) {
          setData({ jobToken: resp.data.convertMedia.jobScheduleId });
        }
        if (resp.error) {
          setError(resp.error);
        }
      });
    }
  }, [createConversion, jobToken, src, targetType, type, validRequest]);

  const media = jobInfo?.job?.mediaUrls?.[0] || jobSubscription?.job?.mediaUrls?.[0];
  useEffect(() => {
    if (media) {
      setData({ outputType: media?.format, outputSrc: media?.url, jobToken: null });
    }
  }, [media]);

  const fetchError = queryError || subscriptionError;
  useEffect(() => {
    if (fetchError) {
      setError(fetchError);
    }
  }, [fetchError]);

  return { isProcessing: !!validRequest, data, error };
};
export default useConvertFile;
